import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { JwtDecoded } from '../modules/domain/models/authentication/jwt-decoded';
import { AuthenticationDomainService } from '../modules/domain/services/authentication/authentication.domain.service';

@Injectable()
export class AuthService {
    constructor(
        private authenticationDomainService: AuthenticationDomainService,
        private router: Router) {
    }

    public getUsername(): string {
        const jwtDecoded: JwtDecoded = this.authenticationDomainService.getDecodedAccessToken();
        if (jwtDecoded) {
            return jwtDecoded.name;
        }
        return '';
    }

    public logout(): void {
        this.authenticationDomainService.logout();
        this.goToLogin();
    }

    public goToLogin(): void {
        this.router.navigate(['login']);
    }

    public isLoggedIn(): boolean {
        const accessToken: string = this.authenticationDomainService.getCurrentAccessToken();
        if (accessToken) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts